import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import styled from 'styled-components';

import RadioOption from '../../radio-group/radio-option';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';

const Label = styled.span`
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 24px;
`;

const Correction = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin: 8px 0 16px 16px;
`;

const RadioOptionsContainer = styled(FluidContainer)`
    margin-left: 16px;
    flex-grow: 0;
`;

const Question = styled.div`
    display: flex;
    align-items: baseline;
`;

const RadioOptionContainer = styled.div`
    margin: 0 8px;
`;

const Index = styled.span`
    font-size: 16px;
    font-weight: 600;
    margin-right: 8px;
`;

export const getLabel = (hasAnswer, correctSelectedAnswer) => {
    if (!hasAnswer) {
        return 'Risposta non data. ';
    }
    return correctSelectedAnswer ? 'Risposta esatta. ' : 'Risposta sbagliata. ';
};

export const getTrueOptionHighlight = (hasAnswer, selectedAnswer, correctAnswer) => {
    const highlightTextTrueOption = hasAnswer
        ? !selectedAnswer
            ? 'normal'
            : correctAnswer === selectedAnswer
              ? 'success'
              : 'error'
        : correctAnswer
          ? 'success'
          : 'normal';
    return highlightTextTrueOption;
};

export const getFalseOptionHighlight = (hasAnswer, selectedAnswer, correctAnswer) => {
    const highlightTextFalseOption = hasAnswer
        ? selectedAnswer
            ? 'normal'
            : correctAnswer === selectedAnswer
              ? 'success'
              : 'error'
        : correctAnswer
          ? 'normal'
          : 'success';
    return highlightTextFalseOption;
};

export const SingleRow = ({
    correctAnswer,
    exerciseId,
    falseString,
    feedback,
    hasAnswer,
    index,
    selectedAnswer,
    solution,
    text,
    trueString,
    showLetter,
}) => {
    const label = getLabel(hasAnswer, correctAnswer === selectedAnswer);
    const isTrueOptionChecked = !hasAnswer ? correctAnswer : selectedAnswer;

    return (
        <FluidContainer flexDirection="column">
            <Question>
                {showLetter && <Index>{`${getCharByElementPosition(index + 1)}.`}</Index>}
                <MathContent style={{ display: 'inline' }}>{text}</MathContent>
            </Question>

            <RadioOptionsContainer>
                <RadioOptionContainer flexWrap="wrap">
                    <RadioOption
                        id={exerciseId}
                        style={{ marginTop: '16px' }}
                        checked={isTrueOptionChecked}
                        disabled={true}
                        highlight={getTrueOptionHighlight(hasAnswer, selectedAnswer, correctAnswer)}
                        name={index.toString()}
                        onChange={() => {}}
                        selected={hasAnswer}
                        value={true}
                    >
                        {trueString !== '' ? trueString : 'Vero'}
                    </RadioOption>
                </RadioOptionContainer>
                <RadioOptionContainer>
                    <RadioOption
                        id={exerciseId}
                        style={{ marginTop: '16px' }}
                        checked={!isTrueOptionChecked}
                        disabled={true}
                        highlight={getFalseOptionHighlight(hasAnswer, selectedAnswer, correctAnswer)}
                        name={index.toString()}
                        onChange={() => {}}
                        selected={hasAnswer}
                        value={false}
                    >
                        {falseString !== '' ? falseString : 'Falso'}
                    </RadioOption>
                </RadioOptionContainer>
            </RadioOptionsContainer>
            <Correction>
                {!solution && <Label>{label}</Label>}
                {solution && feedback && <Label>{'Feedback specifico. '}</Label>}
                {feedback && <MathContent style={{ display: 'inline' }}>{feedback}</MathContent>}
            </Correction>
        </FluidContainer>
    );
};

SingleRow.propTypes = {
    correctAnswer: PropTypes.bool,
    exerciseId: PropTypes.number,
    falseString: PropTypes.string,
    feedback: PropTypes.string,
    hasAnswer: PropTypes.bool,
    index: PropTypes.number,
    selectedAnswer: PropTypes.bool,
    solution: PropTypes.bool,
    text: PropTypes.string,
    trueString: PropTypes.string,
    showLetter: PropTypes.bool,
};

const TrueFalseCorrection = ({ exercise, answers, solution }) => {
    return (
        <FluidContainer flexDirection="column">
            {exercise.questions.map((question, index) => {
                let answer = answers && answers.answer.find((item) => item.questionId === String(question.id));
                let selectedAnswer = get(answer, 'value');

                return (
                    <SingleRow
                        correctAnswer={question.correct}
                        exerciseId={exercise.id}
                        falseString={question.falseString}
                        feedback={question.feedback}
                        hasAnswer={!!answer}
                        index={index}
                        key={index}
                        selectedAnswer={selectedAnswer}
                        solution={solution}
                        text={question.question}
                        trueString={question.trueString}
                        showLetter={exercise.questions.lenght > 1}
                    />
                );
            })}
        </FluidContainer>
    );
};

TrueFalseCorrection.propTypes = {
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    exercise: PropTypes.object,
    solution: PropTypes.bool,
};

export default TrueFalseCorrection;
